import React from "react";
import { useTranslation } from "react-i18next";

const MoodboardDownload = () => {
  const { t } = useTranslation();

  return (
    <section className="moodboard-download">
      <div className="moodboard-content">
        <h2>{t("moodboard.title")}</h2>
        <p>{t("moodboard.description")}</p>
        <a
          href="/downloads/moodboard.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="moodboard-button"
        >
          {t("moodboard.button")}
        </a>
      </div>
    </section>
  );
};

export default MoodboardDownload;
